export default __webpack_public_path__ + "static/media/new-refer-and-earn.7104ed7f.png";